import { nextTick } from "vue";
import { useRouter } from "vue-router";

export default function useModuleNavigation() {
  const router = useRouter();

  const scrollToModuleTop = (targetId = null) => {
    setTimeout(() => {
      const target = targetId ? document.getElementById(targetId) : null;

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 50);
  };

  const tabTarget = (tab) => {
    if (!tab?.url) {
      return null;
    }

    const target = { name: tab.url };

    if (tab.hash) {
      target.hash = tab.hash;
    }

    return target;
  };

  const routeToTab = (tab, options = {}) => {
    if (!tab) {
      return null;
    }

    options.beforeNavigate?.(tab);

    const target = tabTarget(tab);

    if (!target) {
      options.onLocalTab?.(tab);
      if (options.scroll !== false) {
        scrollToModuleTop(options.targetId);
      }
      return null;
    }

    const navigation = options.replace ? router.replace(target) : router.push(target);

    if (options.scroll !== false) {
      Promise.resolve(navigation).finally(() => scrollToModuleTop(options.targetId));
    }

    return navigation;
  };

  const activateLocalTab = (tab, currTab, options = {}) => {
    if (!tab) {
      return;
    }

    options.beforeActivate?.(tab);
    currTab.value = tab;
    options.afterActivate?.(tab);

    if (options.scroll !== false) {
      nextTick(() => scrollToModuleTop(options.targetId));
    }
  };

  return {
    activateLocalTab,
    routeToTab,
    scrollToModuleTop,
    tabTarget,
  };
}
